import { useRef, useMemo } from 'react';
import { useSyncExternalStore } from 'react';
import { yToJS, invalidateAlong } from './_yToJS';

const EMPTY = Object.freeze({});

export function useYMapEntries(yMap) {
    const cacheRef = useRef({ yMap: null, snapshot: EMPTY, dirty: true });

    const { subscribe, getSnapshot } = useMemo(() => {
        cacheRef.current = { yMap, snapshot: EMPTY, dirty: true };

        const subscribe = (listener) => {
            if (!yMap) return () => {};
            const cb = (events) => {
                for (const event of events) {
                    invalidateAlong(yMap, event.path);
                }
                cacheRef.current.dirty = true;
                listener();
            };
            yMap.observeDeep(cb);
            return () => yMap.unobserveDeep(cb);
        };

        const getSnapshot = () => {
            if (!yMap) return EMPTY;
            if (cacheRef.current.dirty) {
                cacheRef.current.snapshot = yToJS(yMap);
                cacheRef.current.dirty = false;
            }
            return cacheRef.current.snapshot;
        };

        return { subscribe, getSnapshot };
    }, [yMap]); // eslint-disable-line

    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
